module.exports = __webpack_public_path__ + "static/img/sunset-visual.5ad0ec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/home/images/sunset-visual.png
// module id = WNUp
// module chunks = 26